<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import moment from 'moment';
 
   export default {
      page: {
         title: "Orders",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         const datetime_now = moment().format("YYYY-MM-DD HH:mm:ss");
         return {
            title: "Orders",
            items: [
               {
                  text: "Orders",
                  active: true,
               },                   
            ],

            orders: [],          
            from: null,
            to: null,
            total: null,
            pagination: {},

            listing_length: 10,
            keyword: '',
            status: '',
            token: "",
            errors: {},          
            active_page_url: null,
            now: datetime_now,

         };
      },
      mounted() {
         this.clearLocalStorage();
      },

      created() {
         this.fetchOrders();
      },

      methods: {
         clearLocalStorage() {
            localStorage.removeItem("consultation_filters");
            localStorage.removeItem("cancel_consultation_filters");
            localStorage.removeItem("patient_filters");
            localStorage.removeItem("doctor_filters");

         },

         fetchOrders(page_url = null) {

            this.getToken();
            let url = "api/admin/pharmacy/orders?keyword=" + this.keyword + "&limit=" + this.listing_length + "&status=" + this.status;

            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;
            
            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.orders = responseData.Orders.data;
                  
                  this.pagination = responseData.Orders.links;
                  this.from = responseData.Orders.from;
                  this.to = responseData.Orders.to;
                  this.total = responseData.Orders.total;
               
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         }, 

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 
         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },

         shipOrder(order_id) {
            this.delete = false;
            this.$bvModal.msgBoxConfirm('Are you sure you want to ship this order?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
            })
            .then(value => {
               this.delete = value
               if(this.delete){
                  this.getToken();           
            
                  const config = {
                     headers: {
                        "Content-type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + this.token,
                     },
                  };
                 
                  let url = "api/admin/pharmacy/orders/dispatch_order?order_id=" + order_id;
                  this.$axios
                  .get(url, config)
                  .then((response) => {
                        if (response.data.status) {
                           this.$swal("", response.data.message, "success");
                        } else {
                           this.$swal("", response.data.message, "error");
                        }
                        this.fetchOrders(this.active_page_url);
                  })
                  .catch((error) => {
                     if (error.response) {
                        if (error.response.data.message) {
                           this.errors = error.response.data.message;
                           //console.log(this.errors);
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  })
                  .finally(() => (this.loading = false));
               }
            })
            .catch(err => {
               console.log(err);
            })
         },
         cancelOrder(order_id) {
            this.delete = false;
            this.$bvModal.msgBoxConfirm('Are you sure you want to cancel this order?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
            })
            .then(value => {
               this.delete = value
               if(this.delete){
                  this.getToken();           
            
                  const config = {
                     headers: {
                        "Content-type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + this.token,
                     },
                  };
                 
                  let url = "api/admin/pharmacy/orders/cancel?order_id=" + order_id;
                  this.$axios
                  .get(url, config)
                  .then((response) => {
                        if (response.data.status) {
                           this.$swal("", response.data.message, "success");
                        } else {
                           this.$swal("", response.data.message, "error");
                        }
                        this.fetchOrders(this.active_page_url);
                  })
                  .catch((error) => {
                     if (error.response) {
                        if (error.response.data.message) {
                           this.errors = error.response.data.message;
                           //console.log(this.errors);
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  })
                  .finally(() => (this.loading = false));
               }
            })
            .catch(err => {
               console.log(err);
            })
         },
         refundOrder(order_id) {
            this.delete = false;
            this.$bvModal.msgBoxConfirm('Are you sure you want to mark this order as refunded?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
            })
            .then(value => {
               this.delete = value
               if(this.delete){
                  this.getToken();           
            
                  const config = {
                     headers: {
                        "Content-type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + this.token,
                     },
                  };
                 
                  let url = "api/admin/pharmacy/orders/refund?order_id=" + order_id;
                  this.$axios
                  .get(url, config)
                  .then((response) => {
                        if (response.data.status) {
                           this.$swal("", response.data.message, "success");
                        } else {
                           this.$swal("", response.data.message, "error");
                        }
                        this.fetchOrders(this.active_page_url);
                  })
                  .catch((error) => {
                     if (error.response) {
                        if (error.response.data.message) {
                           this.errors = error.response.data.message;
                           //console.log(this.errors);
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  })
                  .finally(() => (this.loading = false));
               }
            })
            .catch(err => {
               console.log(err);
            })
         },

         completeOrder(order_id) {
            this.delete = false;
            this.$bvModal.msgBoxConfirm('Are you sure you want to complete this order?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
            })
            .then(value => {
               this.delete = value
               if(this.delete){
                  this.getToken();           
            
                  const config = {
                     headers: {
                        "Content-type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + this.token,
                     },
                  };
                 
                  let url = "api/admin/pharmacy/orders/complete_order?order_id=" + order_id;
                  this.$axios
                  .get(url, config)
                  .then((response) => {
                        if (response.data.status) {
                           this.$swal("", response.data.message, "success");
                        } else {
                           this.$swal("", response.data.message, "error");
                        }
                        this.fetchOrders(this.active_page_url);
                  })
                  .catch((error) => {
                     if (error.response) {
                        if (error.response.data.message) {
                           this.errors = error.response.data.message;
                           //console.log(this.errors);
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  })
                  .finally(() => (this.loading = false));
               }
            })
            .catch(err => {
               console.log(err);
            })
         },

         downloadInvoice(id) {
            let url = "api/downloadOrderInvoice?order_id=" + id;
            this.getToken();
            this.loading = true;
            this.$axios
               .get(url, {
                     headers: { Authorization: "Bearer " + this.token },
                     responseType: "blob" 
               })
               .then((res) => {
                     const blob = new Blob([res.data], { type: "application/pdf" });
                     const url = window.URL.createObjectURL(blob);
                     const link = document.createElement("a");
                     link.href = url;
                     link.download = "invoice.pdf"; 
                     link.click();
                     window.URL.revokeObjectURL(url);
               })
               .catch((error) => {
                  console.error("Error downloading PDF file:", error);
                  const reader = new FileReader();
                  reader.onload = (event) => {
                     const text = event.target.result;
                     const errorData = JSON.parse(text);
                     const errorMessage = errorData.message;
                     if(errorMessage){
                        this.errors = errorMessage;
                     }else{
                     this.$swal("", "Failed to download PDF file", "error");
                     }
                  };
                  reader.readAsText(error.response.data);
               })
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <router-link :to="{ name: 'pharmacy.orders.add' }" class="btn btn-primary float-end">Add Order</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchOrders()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchOrders()"/>
                           </label>
                        </div> 

                        <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="status" @change="fetchOrders()">
                                 <option value="">All</option>
                                 <option value="2">Placed</option>
                                 <option value="3">Packed</option>
                                 <option value="4">Dispatched</option>
                                 <option value="5">Delivered</option>
                                 <option value="6">Cancelled</option>
                              </select>
                           </label>
                        </div>                         
                        
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th>ID</th>
                              <th>Patient Details</th>                 
                              <th>Medicine Price</th>
                              <th>Delivery Type & Delivery Charge</th>
                              <th>Total</th>  
                              <th>Delivery Date & Time</th>
                              <th>Payment Type</th> 
                              <th>Status</th> 
                              <th>Created by</th>
                              <th>Created on</th>
                              <th>Options</th>
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(orders.length)">
                           <tr v-for="(order) in orders" :key="order.id">
                              <td>{{order.order_id}}</td>
                              <td>{{order.name}}<br>
                                 <span v-if="order.order_phone">
                                    {{order.order_country_code}} {{order.order_phone}}<br>
                                    {{order.email}}<br>
                                 </span>
                                 <span v-else>
                                    {{order.profile_country_code}} {{order.profile_phone}}<br>
                                    {{order.email}}<br>
                                 </span></td>                       
                             
                              <td>Rs. {{order.price}}</td>
                              <td>
                                 <span v-if="order.delivery_type==1">Regular</span>
                                 <span v-if="order.delivery_type==2">Express</span><br>
                                 {{order.delivery_charge}}
                              </td> 
                              <td>{{ order.total }}</td>                
                              <td>{{order.delivery_date + ' ' + order.delivery_time | formatDateTime }}</td>
                              <td>  <span v-if="order.payment_type">
                                 <span v-if="order.payment_type=='COD'">COD</span>
                                 <span v-else>Online</span></span>
                              </td>

                              <td>
                                 <span v-if="order.status==2">Placed</span>
                                 <span v-if="order.status==3">Packed</span>
                                 <span v-if="order.status==4">Dispatched</span>
                                 <span v-if="order.status==5">Delivered</span>
                                 <span v-if="order.status==6">Cancelled<br>
                                    <span v-if="order.payment_id">
                                       Refund: 
                                       <span v-if="order.refund_status==1">Pending</span>
                                       <span v-if="order.refund_status==2">Completed</span>
                                    </span>
                                 </span>

                              </td>
                              <td>
                                 <span v-if="order.added_by==1">Patient</span>
                                 <span v-if="order.added_by==2">Admin</span>
                              </td>
                              <td>{{order.converted_created_at}}</td>
                             
                              <td>

                                 <router-link :to="{ name: 'pharmacy.orders.details', params: {id: order.order_id} }" class="btn btn-primary me-2 mb-2 btn-sm">Details</router-link>

                                 <router-link v-if="order.status==5" :to="{ name: 'pharmacy.orders.reorder', params: {id: order.order_id, pid: order.patient_id} } " class="btn btn-primary me-2 mb-2 btn-sm">Reorder</router-link>

                                 <b-button v-if="order.status==3" variant="warning" class="me-2 mb-2 btn-sm" @click="shipOrder(order.order_id)">Mark as Dispatched</b-button>   
                                 
                                 <b-button v-if="order.status==4" variant="success" class="me-2 mb-2 btn-sm"  @click="completeOrder(order.order_id)">Mark as Completed</b-button> 
                                 
                                 <button v-if="order.invoice" @click="downloadInvoice(order.order_id)" class="btn btn-success me-2 mb-2 btn-sm" type="button" >Download Invoice</button>

                                 <!-- <span v-if="order.status != 6"> -->
                                    <button @click="cancelOrder(order.order_id)" class="btn btn-danger me-2 mb-2 btn-sm" type="button" v-if="order.status != 5 && order.status != 6">Cancel</button>
                                 <!-- </span> -->
                                 <button @click="refundOrder(order.order_id)" class="btn btn-success me-2 mb-2 btn-sm" type="button" v-if="order.status == 6 && order.refund_status == 1 && order.payment_id">Mark as Refunded</button>

                              </td>
                           </tr>
                 
                        </tbody>

                        <tbody v-else>
                           <tr>
                              <td colspan="8" class="text-center">No orders found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts ---> 
                  <caption v-if="Boolean(orders.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchOrders(page.url + '&limit='+ listing_length + '&keyword=' + keyword + '&status=' + status )">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->    

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
